export default function buildFormatLongFn (args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {}
    var width = options.width ? String(options.width) : args.defaultWidth
    var format = args.formats[width] || args.formats[args.defaultWidth]
    return format
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
// module id = 621
// module chunks = 12